import React, {useEffect, useRef, useState} from "react";
import './buttonSaveEdit.css';
import {FormattedMessage} from "react-intl";
import {show} from "react-modal/lib/helpers/ariaAppHider";
import {useSelector} from "react-redux";
import users from "../../users";

function InputSaveEdit({
                           inputValue,
                           onSave,
                           label,
                           startEditing,
                           maxLength,
                           id,
                           alwaysEditing,
                           textArea,
                           required = true,
                           showLabel
                       }) {

    let [value, setValue] = useState(inputValue);
    const [editing, setEditing] = useState(startEditing);
    const inputRef = useRef(null);
    const [invalid, setInvalid] = useState(false);
    const darkMode = useSelector(users.selectors.isDarkMode);

    useEffect(() => {
        if (alwaysEditing) {
            setEditing(true);
        }
        if (!inputValue) {
            setEditing(true);
        }
        if (startEditing && inputRef) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    }, []);

    useEffect(() => {
        setValue(inputValue);
    }, [inputValue])

    const toggleEdit = () => {
        if (editing) {
            if (!value && required) {
                setInvalid(true);
                if (alwaysEditing) {
                    onSave(value);
                }
                return;
            }
            setInvalid(false);
            onSave(value);
        }
        if (!alwaysEditing) {
            setEditing(!editing);
        }
    }

    const cancelEdit = () => {
        if (editing) {
            onSave(inputValue);
            setValue(inputValue);
        }
        setEditing(!editing);
    }

    const checkEnter = (e) => {
        if (e.key === 'Enter') {
            toggleEdit();
        }
        if (e.key === 'Escape') {
            cancelEdit();
        }
    }

    return (
        <div className="col-12 d-flex flex-wrap">
            {label && showLabel && <label style={{fontWeight: "bold"}} htmlFor={id ?? "userInput"}>{label}{required && " *"}</label>}
            <div className={"input-group mb-1 col-12 " + (invalid && "is-invalid")}>
                {!textArea && <input id={id ?? "userInput"} value={value} onChange={e => {
                    setValue(e.target.value);
                    value = e.target.value;
                    if (alwaysEditing) {
                        toggleEdit();
                    }
                }} autoComplete="false" disabled={!editing} onKeyDown={checkEnter}
                                     type="text" className={"form-control " + (invalid && "is-invalid")}
                                     maxLength={isNaN(maxLength) ? 20 : maxLength}
                                     placeholder={label} ref={inputRef}/>}
                {textArea &&
                    <div className="col-12">

                        <textarea className="form-control" placeholder={textArea.placeHolder}
                                  maxLength={maxLength} value={value} id="floatingTextarea"
                                  onChange={e => {
                                      setValue(e.target.value);
                                      value = e.target.value;
                                      if (alwaysEditing) {
                                          toggleEdit();
                                      }
                                  }}></textarea>
                        <div className="text-end">
                            <small>{value.length}/{maxLength}</small>
                        </div>
                    </div>

                }
                {!alwaysEditing && <span style={{
                    width: '42px', cursor: 'pointer',
                    backgroundColor: darkMode ? "#2b3035" : "white"
                }}
                                         className="input-group-text d-flex justify-content-center button-edit"
                                         onClick={toggleEdit}>
                    {!editing && <i className="fa-solid fa-pen-to-square"/>}
                    {editing && <i className="fa-solid fa-floppy-disk"/>}
                </span>}
            </div>
            <div id="validationSelector" className="invalid-feedback">
                <FormattedMessage id="input-save-edit.invalid-feedback"/>
            </div>
        </div>
    )
}

export default InputSaveEdit;
